import React from 'react';
import { UI_STYLES } from "../../styles/uiStyles";
import passwordOff from "@/assets/img/icons/passwordOff.svg";
import passwordOn from "@/assets/img/icons/passwordOn.svg";

interface PasswordInputProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string | null;
  visible: boolean;
  onToggleVisibility: () => void;
  autoComplete?: string;
  className?: string;
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
  id,
  label,
  value,
  onChange,
  error,
  visible,
  onToggleVisibility,
  autoComplete = 'off',
  className = ''
}) => {
  return (
    <div className={className}>
      <label className="block text-white/80 mb-2 text-start text-sm" htmlFor={id}>
        {label}
      </label>
      <div className="relative">
        <input
          id={id}
          type={visible ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={`w-full bg-transparent border-b border-white/30 text-white py-0 px-1 focus:outline-none ${UI_STYLES.emeraldBorderColorFocus} transition`}
          autoComplete={autoComplete}
        />
      <img
          onClick={onToggleVisibility}
          src={
            visible
              ? passwordOff
              : passwordOn
          }
          alt="eye"
          className="w-[40px] h-[40px] cursor-pointer absolute bottom-0 right-0 px-2 py-2  z-10" 
        />
      </div>

      <div className="text-red-400 text-xs text-start mt-0" style={{visibility: error ? 'visible' : 'hidden'}}>{error || 'error'}</div>
    </div>
  );
};

export default PasswordInput; 
